import { createTheme } from "@mui/material";
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const CustomTheme = createTheme({
  palette: {
    primary: {
      main: "#5568A0", //"#528CD6",#213F6D, #5568A0
      dark: "#213F6D",
      light: "#BDBBBB", //"#A3D4E8",
    },
    secondary: {
      main: "#F2704F",
    },
    fontWeights: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    backgroundRight: {
      main: "#5568A0", //"#528CD6",
      dark: "#213F6D",
      light: "#A3D4E8",
      tab: "#DFDFDF", //"#E0F7FA",
    },
    phoneInput: {
      main: "#B7C1DE", //"#E3F2F8",
    },
    otherColors: {
      main: "#FFFFFF",
      backgroundsColors: "#FFFFFF",
      tabText: "#FFFFFF",
      tabBackground: "#242424", //"#213F6D",
      menuIcon: "#5568A0", //"#528CD6",
    },
    barProgress: {
      main: "#5568A0", //"#528CD6",
    },
    marketPlace: {
      main: "#FFFFFF",
      cardBackground: "#C2E5F3",
    },
    cotizador: {
      backgroundColor: "#D8D8D8D8", //"#E3F2F8",
      barColor: "#5568A0",
      iconColor: "#BDBBBB",
      markLabelColor: "#BDBBBB",
    },
    buttonSelected: {
      backgroundColor: "#D8D8D8D8", //"#528CD6",
      backgroundColorActive: "#5568A0",
      textColor: "#333F48",
      textColorActive: "#FFFFFF",
      bordeColorActive: "#5568A0",
    },
    screenBackground: {
      backgroundColor: "#FFFFFF",
      textColor: "#49A942",
      iconColor: "#49A942",
      subTextColor: "#2C2C2C",

      backgroundColorBofu: "#FFFFFF",
      textColorBofu: "#49A942",
      iconColorBofu: "#49A942",
      subTextColorBofu: "#2C2C2C",
    },
  },
  typography: {
    fontFamily: ["Outfit"].join(","),
    h1: {
      fontSize: 39,
      fontWeight: 300,
    },
    h2: {
      fontSize: 31,
      fontWeight: 300,
    },
    h3: {
      fontSize: 25,
      fontWeight: 300,
    },
    h4: {
      fontSize: 20,
      fontWeight: 300,
    },
    h5: {
      fontSize: 16,
      fontWeight: 300,
    },
    body1: {
      fontSize: 16,
      fontWeight: 300,
    },
    body2: {
      fontSize: 13,
      fontWeight: 300,
    },
    body3: {
      fontSize: 11,
      fontWeight: 300,
      fontFamily: "Outfit",
    },
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#BDBBBB", // "#A3D4E8",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "4D4D4D", // "#A3D4E8",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
          "& .MuiFilledInput-root": {
            borderRadius: "10px",
          },
          "& .MuiInputBase-root": {
            borderRadius: "10px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#BDBBBB", //"#A3D4E8",
          },
          "& .MuiInput-underline::before": {
            borderColor: "#BDBBBB", //"#A3D4E8",
          },
          "& .MuiFilledInput-underline::before": {
            borderColor: "#BDBBBB", //"#A3D4E8",
          },
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          padding: "10px 25px",
          textTransform: "none",
          fontSize: 16,
          fontWeight: 700,
        },
      },
      variants: [
        {
          props: {
            variant: "default",
          },
          style: {
            backgroundColor: "#5568A0", //"#528CD6",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#5568A0", //"#528CD6",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#213F6D",
              color: "#A3D4E8",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "default_disabled",
          },
          style: {
            backgroundColor: "#5568A0", //"#528CD6",
            opacity: 0.4,
            color: "#FFF",
            // "&.Mui-disabled": {
            //   backgroundColor: "#5568A0", //"#528CD6",
            //   opacity: 0.4,
            //   color: "#FFF",
            // },
            "&:hover": {
              backgroundColor: "#5568A0", //"#528CD6",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "contained",
          },
          style: {
            "&.Mui-disabled": {
              backgroundColor: "#5568A0", //"#528CD6",
              opacity: 0.4,
              color: "#ffffff",
            },
          },
        },
        {
          props: {
            variant: "orange",
          },
          style: {
            backgroundColor: "#F2704F",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#F2704F",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#F2704F",
            },
          },
        },
        {
          props: {
            variant: "black",
          },
          style: {
            backgroundColor: "#2C2C2C",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#2C2C2C",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#2C2C2C",
            },
          },
        },
        {
          props: {
            variant: "blue_outlined",
          },
          style: {
            color: "#213F6D",
            backgroundColor: "#FFF",
            border: "2px solid #213F6D",
            lineHeight: "22px",
            "&.Mui-disabled": {
              color: "#bdbdbd",
              border: "2px solid #bdbdbd",
              backgroundColor: "transparent",
            },
            "&.MuiButton-blue_outlinedSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "blue_demon",
          },
          style: {
            // color: "#A3D4E8",
            color: "#FFFFFF",
            backgroundColor: "#213F6D",
            "&.Mui-disabled": {
              color: "#FFFFFF",
              backgroundColor: "#213F6D",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#213F6D",
            },
          },
        },
        {
          props: {
            variant: "green",
          },
          style: {
            color: "#FFFFFF",
            backgroundColor: "#00BB2D",
            "&.Mui-disabled": {
              backgroundColor: "#009A24",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#009A24",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
          },
          style: {
            width: "150px",
            height: "30px",
            fontSize: 15,
            color: "#5568A0", //"#528CD6",
            backgroundColor: "#A3D4E8",
            "&.Mui-disabled": {
              backgroundColor: "#A3D4E8",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#A3D4E8",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "expediente",
          },
          style: {
            paddingLeft: "10px",
            paddingRight: "10px",
            width: "150px",
            height: "30px",
            fontSize: 15,
            backgroundColor: "#5568A0", //"#528CD6",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#5568A0", //"#528CD6",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#213F6D",
              color: "#A3D4E8",
            },
          },
        },
        {
          props: {
            variant: "expediente",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "yellow",
          },
          style: {
            backgroundColor: "#FF9D14",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#FF9D14",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#FF9D14",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
      ],
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "#FF6060",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#BDBBBB", // Borde azul cuando no está enfocado
              borderRadius: "4px",
            },
            "&:hover fieldset": {
              borderColor: "#BDBBBB", // Borde azul al pasar el cursor
            },
            "&.Mui-focused fieldset": {
              borderColor: "#BDBBBB", // Borde azul cuando está enfocado
            },
          },
          "& .MuiSelect-icon": {
            color: "#BDBBBB", // Color del icono de selección
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          // "& .MuiSelect-icon": {
          //   color: "#A3D4E8",
          // },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#BDBBBB",
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: "14px",
          boxShadow: "8px 4px 20px 0px rgba(82, 140, 214, 0.25)",
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          // backgroundColor: "rgba(0, 0, 0, 0.5)",
          // border: "2px red solid"
          // ".aria-labelledby": {
          //   border: "2px blue solid"
          // }
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        determinate: {
          color: "#A3D4E8",
        },
        indeterminate: {
          color: "#5568A0", //"#528CD6",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: "#333F48",
        },
      },
    },
  },
});

export const interfaceConfig: InterfaceConfig = {
  name: "providencia",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  interest_rate: 30,
  metadata: {
    title: "CasoFin",
    description:
      "Lendia es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "casofin/portal/logos/favicon.ico",
    ogImage: "https://lendia.mx/opengraph-image.png?5ab5b324c6780cbc",
  },
  navbar: {
    logo: "casofin/portal/logos/logo.png",
    logo_width: 110,
    logo_height: 40,
    logo_menu_lateral: "providencia/portal/logos/logo_menu_lateral.svg",
  },
  lateral: {
    logo_width: 250,
    logo_height: 50,
    logo_dark: "casofin/portal/logos/logo_dark.png",
    bg_light: CustomTheme.palette.primary.main,
    text_light: "#FFFFFF",
    logo_light: "casofin/portal/logos/logo_light.png",
    bg_dark: CustomTheme.palette.primary.dark,
    text_dark: "#FFFFFF",
    image_list: [
      "casofin/portal/lateral/imagen_1.webp",
      "casofin/portal/lateral/imagen_2.webp",
      "casofin/portal/lateral/imagen_3.webp",
      "casofin/portal/lateral/imagen_4.webp",
      "casofin/portal/lateral/imagen_5.webp",
      "casofin/portal/lateral/imagen_6.webp",
      "casofin/portal/lateral/imagen_7.webp",
      "casofin/portal/lateral/imagen_8.webp",
      "casofin/portal/lateral/imagen_9.webp",
      "casofin/portal/lateral/imagen_10.webp",
    ],
    text_list: [
      "Así de fácil: solicita, compara, avanza",
      "Tu crédito, tu elección, tu crecimiento",
      "Crédito simple, procesos simples",
      "Avanza con las mejores condiciones del mercado",
      "Compara y decide: tu crédito, tus reglas",
      "Un solo lugar, todas las opciones de financiamiento",
      "Crecer nunca fue tan sencillo",
      "Descubre la mejor solución para tu PyME",
      "El poder de elegir está en tus manos",
      "Da el paso que tu empresa necesita",
    ],
  },
  textos_tofu: {
    pm: {
      crear_cuenta: {
        titulo: "Te damos la bienvenida",
        sub_titulo: "",
      },
      registro_datos_personales: {
        titulo: "Creación de cuenta",
        sub_titulo: "",
      },
      validacion_telefono: {
        titulo: "Validación de teléfono",
        sub_titulo: "",
      },
      datos_empresa_pm: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      consulta_ciec: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      uso_de_credito: {
        titulo: "Selección de uso de crédito",
        sub_titulo: "",
      },
      presencia_digital_pm: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      consulta_buro_nip: {
        titulo: "Validación para consulta buró",
        sub_titulo: "",
      },
      buro_bloqueado: {
        titulo: "Consulta de Buró de Crédito del Accionista Bloqueada",
        sub_titulo: "",
      },
    },

    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
      consulta_buro_pfae: {
        titulo: "Consulta Buró",
        sub_titulo: "",
      },
      domicilio_pfae: {
        titulo: "Domicilio",
        sub_titulo: "",
      },
      presencia_digital_pfae: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
    },
  },
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyDAtCLTqWu3XTjTC6AT2ZysdXUtL33bAX4"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_xNemClkcb",
      userPoolClientId: "43gc1fvrdk55b6j4g5nq6k21vo",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_FhHFierzr",
      userPoolClientId: "5qvl9t4n2qtvg99rv30t6gqqum",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
